/**
 * MaintenancePage — what the storefront renders when settings/store.is_active
 * is false. Stays minimal: brand wordmark, cream surface, one-line message.
 *
 * Story: STORY-03.4.02 — operator-triggered downtime page.
 *
 * Loaded by MaintenanceGuard in the customer-facing Layout. The admin console
 * (/admin/*) does NOT use Layout, so it stays reachable even when the store
 * is deactivated — that's how the operator reactivates.
 */
import React from 'react';
import 'styles/components/maintenance.css';

const MaintenancePage = ({ storeName, contactEmail }) => (
  <main className="maintenance" role="main">
    <div className="maintenance__inner">
      <div className="maintenance__wordmark">
        <span className="maintenance__wordmark-curated">curated</span>
        <span className="maintenance__wordmark-lagos">LAGOS</span>
      </div>
      <h1 className="maintenance__headline">We'll be back soon.</h1>
      <p className="maintenance__body">
        {storeName || 'Curated Lagos'} is briefly closed for some careful work behind the scenes.
        Existing orders are safe — we'll let you know the moment the doors are open again.
      </p>
      {contactEmail && (
        <p className="maintenance__contact">
          Urgent? Reach us at{' '}
          <a href={`mailto:${contactEmail}`}>{contactEmail}</a>.
        </p>
      )}
    </div>
  </main>
);

export default MaintenancePage;
